import React from 'react';
import AurIcon, {IconNames, IconColors, IconSize} from '../aur-icon/AurIcon';
import {Typography} from '@mui/material';

interface Props {
  label: string;
  icon?: IconNames; // Optional icon
  fontColor?: string; // Customizable font color
  iconColor?: IconColors; // Customizable icon color
  iconSize?: IconSize; // Customizable icon size
}

const AurPill: React.FC<Props> = (props: Props) => {
  const {label, icon, fontColor, iconColor, iconSize} = props;

  return (
    <div className="pill-container">
      {icon && <AurIcon icon={icon} color={iconColor} size={iconSize} />}
      <Typography
        style={{color: fontColor}}
        className="typo-text body2_size pill-text-color"
      >
        {label}
      </Typography>
    </div>
  );
};

export default AurPill;
